import { useEffect, useState } from "react";
import { useTimeclockStats } from "@/hooks/admin/useAdminData";

export default function LiveClock() {
  const [now, setNow] = useState(new Date());
  const { onClock, avgTodayHours, laborTodayCents, loading } = useTimeclockStats();

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const time = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const date = now.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const laborDollars = Math.round(laborTodayCents / 100);

  return (
    <div className="bg-gradient-to-br from-ink-900 via-ink-800 to-ink-900 rounded-lg p-6 text-white overflow-hidden relative">
      <div className="absolute -right-12 -top-12 w-48 h-48 rounded-full bg-brand-500/20 blur-3xl"></div>
      <div className="absolute -left-8 -bottom-8 w-32 h-32 rounded-full bg-brand-400/10 blur-2xl"></div>

      <div className="relative">
        <div className="flex items-center gap-2 mb-1">
          <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-brand-300 bg-brand-500/10 px-2 py-1 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-400 animate-pulse"></span>
            Live
          </span>
          <span className="text-xs text-ink-300">{date}</span>
        </div>
        <div className="font-display text-5xl md:text-6xl font-bold tabular-nums tracking-tight">
          {time}
        </div>
        <p className="text-xs text-ink-300 mt-2 max-w-md leading-relaxed">
          Hours auto-calculate the moment crew clock out. Approvals roll up to payroll every Sunday.
        </p>

        <div className="grid grid-cols-3 gap-3 mt-5 pt-5 border-t border-white/10">
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-wider text-ink-300">
              On Clock
            </div>
            <div className="font-display text-2xl font-bold tabular-nums mt-0.5">
              {loading ? "—" : onClock}
            </div>
          </div>
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-wider text-ink-300">
              Avg Today
            </div>
            <div className="font-display text-2xl font-bold tabular-nums mt-0.5">
              {loading ? "—" : `${avgTodayHours.toFixed(1)}h`}
            </div>
          </div>
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-wider text-ink-300">
              Labor (Today)
            </div>
            <div className="font-display text-2xl font-bold tabular-nums mt-0.5">
              {loading ? "—" : `$${laborDollars.toLocaleString()}`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}